{
  "(optional)": "(valgfritt)",
  "(required)": "(obligatorisk)"
}